<section class="bk-panel panel panel--flush checks" aria-labelledby="sb-checks-title">
  <header class="panel__head">
    <div class="panel__titles">
      <h2 class="bk-section-title panel__title" id="sb-checks-title">Rows to check</h2>
      <p class="panel__sub">
        @if (counts().all) {
          {{ formatCount(counts().all) }} {{ counts().all === 1 ? "row needs" : "rows need" }} a look. Open a row to
          see its message.
        } @else {
          Nothing to check.
        }
      </p>
    </div>
    @if (filtered().length) {
      <button type="button" class="bk-btn bk-btn--ghost" (click)="download()">
        <span class="bk-sym" aria-hidden="true">download</span>
        Download these rows
      </button>
    }
  </header>

  @if (counts().all) {
    <div class="panel__inset">
      <div class="seg" role="group" aria-label="Show rows">
        @for (item of filters; track item.id) {
          @if (item.id === "all" || counts()[item.id]) {
            <button
              type="button"
              class="seg__btn"
              [attr.aria-pressed]="filter() === item.id"
              (click)="setFilter(item.id)"
            >
              {{ item.label }}
              <span class="seg__count">{{ formatCount(counts()[item.id]) }}</span>
            </button>
          }
        }
      </div>
    </div>

    <div class="table-wrap checks__wrap">
      <table class="bk-log">
        <thead>
          <tr>
            <th scope="col" class="num col-row">Row</th>
            <th scope="col" class="col-number">Number</th>
            <th scope="col" class="col-issue">What we found</th>
            <th scope="col" class="col-outcome">What happens</th>
            <th scope="col" class="col-go"><span class="bk-sr-only">Open</span></th>
          </tr>
        </thead>
        <tbody>
          @for (problem of visible(); track problem.row) {
            <tr
              class="is-link"
              tabindex="0"
              (click)="open(problem.row)"
              (keydown.enter)="openFromKeyboard($event, problem.row)"
            >
              <td class="num quiet col-row">{{ problem.sheetRow }}</td>
              <td class="col-number">
                <span class="cell-clip">{{ problem.number || "—" }}</span>
              </td>
              <td class="col-issue">
                <!-- Narrow panels hide the Number and What happens columns;
                     these copies show them here instead. -->
                <span class="issue-number">{{ problem.number || "No number" }}</span>
                @for (issue of problem.issues; track $index) {
                  <span class="issue" [attr.data-tone]="issue.tone">
                    {{ issue.text }}
                    <span class="issue__outcome">{{ issue.outcome }}</span>
                  </span>
                }
              </td>
              <td class="quiet col-outcome">
                @for (issue of problem.issues; track $index) {
                  <span class="outcome">{{ issue.outcome }}</span>
                }
              </td>
              <td class="col-go">
                <span class="bk-sr-only">Preview this row</span>
                <span class="bk-sym row-go" aria-hidden="true">chevron_right</span>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    @if (filtered().length > visible().length) {
      <div class="panel__inset checks__more">
        <button type="button" class="bk-more" (click)="showMore()">
          Show {{ formatCount(nextBatch()) }} more of {{ formatCount(hidden()) }}
          <span class="bk-sym" aria-hidden="true">expand_more</span>
        </button>
      </div>
    } @else {
      <div class="checks__end"></div>
    }
  } @else {
    <div class="panel__inset checks__clear">
      <ul class="notes">
        <li class="note" data-tone="ok">
          <span>Every row has a valid number, a value for each field and the usual length.</span>
        </li>
      </ul>
    </div>
  }
</section>
